<!-- 掛在 appinfo(上板相關) 的頁籤裡，外層的 tab 由 appinfo 畫 -->
<div class="cfg-wrap">

    <div class="cfg-alert" *ngIf="missing.length>0">
        <span class="cfg-alert-icon">⚠️</span>
        <div class="cfg-alert-text">
            config 少了這幾筆設定
            <div class="cfg-alert-sub">{{ missing_text() }}</div>
        </div>
        <button class="cfg-btn cfg-btn-warn" (click)="init_config()">點我補建</button>
    </div>

    <div class="cfg-card" *ngIf="data.length>0">
        <div class="cfg-card-head">
            <div>
                <div class="cfg-card-title">App 開關設定</div>
                <div class="cfg-card-sub">改完存檔會一併清掉 config 的快取，App 端即時生效</div>
            </div>
            <button class="cfg-btn cfg-btn-ghost" (click)="init_list()">重新載入</button>
        </div>

        <div class="cfg-table-scroll">
            <table class="cfg-table">
                <thead>
                    <tr>
                        <th style="width:24%">設定項目</th>
                        <th style="width:24%">CONFIG title</th>
                        <th style="width:14%">編輯欄位</th>
                        <th style="width:24%">設定值</th>
                        <th style="width:14%">最後更新</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of data; let i = index" [class.is-changed]="is_changed(item,i)">
                        <td>
                            <div class="cfg-name">
                                {{item.name}}
                                <span class="cfg-dot" *ngIf="is_changed(item,i)">已修改</span>
                            </div>
                            <div class="cfg-note">{{item.note}}</div>
                            <div class="cfg-warn" *ngIf="item.is_enable!=1">is_enable = 0，App 端讀不到這筆</div>
                        </td>
                        <td><code class="cfg-key">{{item.title}}</code></td>
                        <td>
                            <span class="cfg-tag" *ngIf="item.field">type {{item.type}} → {{item.field}}</span>
                            <span class="cfg-tag cfg-tag-off" *ngIf="!item.field">type {{item.type}} 不給改</span>
                        </td>
                        <td>
                            <div class="cfg-seg" *ngIf="item.input=='switch'">
                                <button class="cfg-seg-btn" [class.on]="item.value*1==1" (click)="item.value='1'">啟用</button>
                                <button class="cfg-seg-btn" [class.off]="item.value*1!=1" (click)="item.value='0'">關閉</button>
                            </div>
                            <input *ngIf="item.input=='text'" type="text" class="cfg-input" [(ngModel)]="item.value" placeholder="留空代表不顯示">
                            <span class="cfg-readonly" *ngIf="!item.field">{{item.value===''?'(空白)':item.value}}</span>

                            <div class="cfg-diff" *ngIf="ori_data[i] && is_changed(item,i)">
                                {{ ori_data[i].value===''?'(空白)':ori_data[i].value }}
                                <span class="cfg-arrow">→</span>
                                <b>{{ item.value===''?'(空白)':item.value }}</b>
                            </div>
                        </td>
                        <td class="cfg-time">{{item.update_dt}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="cfg-card-foot">
            <span class="cfg-foot-msg" *ngIf="changed_list().length>0">有 {{changed_list().length}} 筆未儲存</span>
            <span class="cfg-foot-msg cfg-foot-idle" *ngIf="changed_list().length==0">目前沒有變更</span>
            <button class="cfg-btn cfg-btn-ghost" (click)="reset()" [disabled]="changed_list().length==0">取消變更</button>
            <button class="cfg-btn cfg-btn-main" (click)="save()" [disabled]="changed_list().length==0">儲存</button>
        </div>
    </div>

    <div class="cfg-empty" *ngIf="data.length==0 && missing.length==0">無資料</div>

    <app-toast></app-toast>
</div>
<app-spinner [loading]="loading"></app-spinner>
